import { Observable } from 'rxjs';
import { AG_RENDER_BUTTON_OPTIONS } from './ag-grid.models';

export interface AgTwoButtonConfig {
  displayAll: AG_RENDER_BUTTON_OPTIONS;
  btn1: AgButtonRender;
  btn2: AgButtonRender;
}

export interface AgButtonRender {
  type: AgButtonType;
  value: string;
  enable: boolean;
}

export enum AgButtonType {
  PRIMATY = 'primary',
  SECONDATY = 'secondary',
  TERTIARY = 'tertiary',
}

export type AllocationAction = 'deallocate' | 'reallocate';

export const ALLOCATION_ACTIONS = {
  DEALLOCATE: 'deallocate',
  REALLOCATE: 'reallocate',
} as const;

export interface UpdateUserDescriptionPayload {
  allocationId: string;
  entitlementId: string;
  userDescription: string;
}

export type UpdateUserDescriptionHandler = (payload: UpdateUserDescriptionPayload) => Observable<boolean> | void;
